import React from "react"
import Button from "../../../../../core/gd-components/buttons/gd-button/gd-button-ui5-new"
import SettingsButton from "../../../../../core/gd-components/rich-editor/settings-button/settings-button"

type Props = {
    parent  : {
        saveButton: false | 'primary' | 'busy'
    }

    onSave  : {():void}
}

const debug = false
// const debug = "RightControls"

export default class RightControls extends React.Component<Props, any> {

    constructor(props:Props) {
        super(props);

        debug && console.log(debug, 'constructor', props.parent.saveButton)

        this.state = {
            saveButton: props.parent.saveButton
        }
    }

    componentDidMount() {
        gd.bus.subscribe('document:save-button', this, this.onSaveButtonChange)
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    onSaveButtonChange = (value:false | 'primary' | 'busy') => {
        debug && console.log(debug, 'onSaveButtonChange', value)

        this.setState({
            saveButton: value
        })
    }

    render() {
        debug && console.log(debug, 'render', this.state.saveButton)

        return (
            <React.Fragment>
                <div className="gd-draftail-toolbar-group no-separator">
                    <SettingsButton className="ui5-control-button s-26"
                                    hideToolbarAllowed={false}/>
                </div>
                {!!this.state.saveButton &&
                    <div className="save-button-container">
                        <Button label="Save"
                                type={this.state.saveButton}
                                className="flex min-w-75"
                                size="30"
                                onClick={this.props.onSave}/>
                    </div>}
            </React.Fragment>
        )
    }
}